// extracted by css-extract-rspack-plugin
export default {"header":"PeVymmDf06JdU7oE","heading":"uEhYrqrPbEyZrrqG","description":"tZhQseS9FSg2tVD5"};